export default function moneyFormat(money: number | undefined | typeof NaN | null) {
  return money !== null && money !== undefined && !Number.isNaN(money)
    ? money.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      })
    : '';
}
